import { observer } from "mobx-react-lite";

const AdsGenerationBrandsTemplates = () => {
	return <></>;
};

export default observer(AdsGenerationBrandsTemplates);
